module.exports = __webpack_public_path__ + "img/feature_e04.60292c26.svg";